import { useActionState, useEffect } from "react";
import { Button } from "../../../../components/button";
import { signin } from "../actions";

export function GoogleSignIn({visible}:{visible:boolean}) {
  const [state, formAction, isPending] = useActionState(signin, null);
  useEffect(() => {
    if (state?.success)
      window.open(state.url, "_blank");    
  }, [state])
  if(!visible)
    return null;
  return (
  
      <Button
        type="button"
        disabled={isPending}
        className="min-w-[90px] bg-green-200"
        loading={isPending}
        onClick={formAction}
      >
        Signin
      </Button>
  
  );
}
